import React from "react";
import { API_URL } from "../config";

function TinyReklama({ ads, animate }) {
  let tinyAd = null;
  ads?.forEach((ad) => {
    if (ad.size === "small") {
      tinyAd = ad.image;
    }
  });

  return (
    <div
      style={{ marginTop: "20px" }}
      data-aos={animate === false ? "none" : "fade-up"}
      className="d-flex align-items-center justify-content-center"
    >
      {tinyAd ? (
        <img
          style={{
            maxWidth: "100%",
            maxHeight: "147px",
          }}
          src={`${API_URL}/` + tinyAd}
        />
      ) : (
        "Vaša reklama na: 067 XXX XXX"
      )}
    </div>
  );
}

export default TinyReklama;
